import { YesObject } from '@yes.technology/react-toolkit'
import { useEffect, useRef } from 'react'

const openDropdownOnInput = (input: HTMLInputElement) => {
  if (document.activeElement === input) {
    input.blur()
  }
  input.focus()
}

const useOpenDropdownOnResults = (
  isLoading: boolean,
  suggestions: YesObject[],
  inputRef: React.Ref<HTMLInputElement> | undefined,
  isUserEditing: boolean
) => {
  const prevIsLoadingRef = useRef(isLoading)
  const prevSuggestionsLengthRef = useRef(suggestions.length)

  useEffect(() => {
    const wasLoading = prevIsLoadingRef.current
    const previousSuggestionsLength = prevSuggestionsLengthRef.current
    prevIsLoadingRef.current = isLoading
    prevSuggestionsLengthRef.current = suggestions.length

    const input =
      inputRef && typeof inputRef !== 'function' ? inputRef.current : null

    if (!input || suggestions.length === 0 || isUserEditing) {
      return
    }

    const fetchJustFinished = wasLoading && !isLoading
    const suggestionsJustArrived =
      !isLoading && previousSuggestionsLength === 0 && suggestions.length > 0

    if (!fetchJustFinished && !suggestionsJustArrived) {
      return
    }

    if (document.activeElement === input) {
      openDropdownOnInput(input)
    }
  }, [isLoading, suggestions, isUserEditing])
}

export default useOpenDropdownOnResults
